export default __webpack_public_path__ + "static/media/kitchen5-afterA-768w.96ae5c66.webp";